import * as React from 'react';
import { resolve } from "inversify-react";
import { Row, Col, Button, Pagination, Spin, Alert } from 'antd';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { SearchType } from 'src/app/products/contractSimulator/parts/pax-occupancy.view';
import { SearchResultView } from 'src/app/bookings/search/results/search-results.view';
import { DataLocalService } from 'src/core/services/data-local.service';
import { FormatService } from 'src/core/services/format.service';
import { DateView } from 'src/core/ui/date.view';
import SeachServiceProviderEditor from 'src/app/bookings/shared/product-search-service-providers.editor';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { OccupanciesComponent } from 'src/app/rules/rules/form/parts/executors/parts/occupancies-component';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';

export interface ICacheMetadata {
	keys: { [id: string]: string[] }
	keysCount: { [id: string]: number }
	keyNames: { [id: string]: string }
}

interface IProps {
	data: any;
	onSearch: (query: any, type: SearchType, pageIndex: number, pageSize: number) => void;
	onFlush: () => void;
	pageIndex: number;
	pageSize: number;
	total: number;
	loading: boolean;
	metadata: ICacheMetadata;
	onLoadMetadata: () => void;
}

interface SearchInfo {
	apiServiceName: string[],
	startDate: string,
	endDate: string,
	units: { unit: number, paxs: { id: string, name: string, age: number }[] }[]
}

interface IState {
	searchType: SearchType;
	search: any;

	rawOccupancy: string;
}

@observer
class SearchResultController extends React.Component<{ data: any, searchInfo: SearchInfo, searchType: SearchType }, any>{


	@resolve
	formatService: FormatService;

	@observable
	dataService: DataLocalService<ProductSearchResult>;

	renderExtraInformation = (search: { marketId: number }) => {
		return (
			<div style={{ marginBottom: '8px' }}>
				{/*<Row gutter={24}>
					<Col xs={6}>
						<MarketEditorController
							label='Market'
							value={search.marketId}
							mode='display'
							onChanged={e => { }}
							setBusy={e => { }}
						/>
					</Col>
				</Row>*/}
			</div>
		);
	}

	public componentDidMount() {
		//console.log(this.props.data);
		this.dataService = new DataLocalService(this.props.data as any, 100);
	}

	getSearch = () => {
		const common: any = {
			isActive: true,
			occupancies: [],
			type: this.props.searchType,
			searchInCache: false,
			apiNames: [],
			startDate: new Date(),
			endDate: new Date(),
			contractId: null,
			facets: []
		}

		return common;
	}

	render() {

		if (this.dataService == null)
			return null;

		const { data, searchType } = this.props;
		const chunk = data;
		const searchMade = data.search;

		let search = '';
		search = this.renderSearch(this.props.searchInfo);


		return (<div style={{ padding: '10px' }}>
			{this.renderExtraInformation(chunk.search)}
			<SearchResultView
				count={this.dataService.count}
				fullSreen={false}
				showAllExpanded={true}
				typeSearch={searchType}
				mode="display"
				yourSearch={search}
				setBusy={e => { }}
				model={this.dataService}
				currentSearch={this.getSearch()}
				bookingDate={null}
				languageCode={null}
				marketId={0}
			/>
		</div>);
	}


	renderSearch = (search: SearchInfo) => {
		return 'Service name (Provider): ' + (!!search.apiServiceName ? search.apiServiceName.map((item, index) => item).join(',') : '*') +
			' Start date: ' + (!!search.startDate ? this.formatService.toString('date', search.startDate) : '*') +
			' End date: ' + (!!search.endDate ? this.formatService.toString('date', search.endDate) : '*') +
			' Occupancy: ' +
			(!!search.units ? search.units.map((unit, index) => "Unit: " + unit.unit
				+ ' Paxes: ' + unit.paxs.map((pax, index) => 'Age ' + pax.age + ' Name ' + pax.name).join(',')).join(',') : '*');
	}
}

export class CacheListView extends React.Component<IProps, IState> {


	constructor(props) {
		super(props);

		this.state = {
			searchType: 'Accommodation',
			search: {},
			rawOccupancy: '[]'
		}
	}

	public componentDidMount() {
		this.props.onLoadMetadata();
	}

	fromScratch = () => {
		this.props.onSearch(this.state.search, this.state.searchType, 0, this.props.pageSize);
	}

	onSearch = () => {
		this.props.onSearch(this.state.search, this.state.searchType, this.props.pageIndex, this.props.pageSize);
	}

	onReload = () => {
		this.props.onSearch(this.state.search, this.state.searchType, this.props.pageIndex, this.props.pageSize);
		this.props.onLoadMetadata();
	}

	setProperty = (name: string, value: any) => {

		var newVal = { ...this.state.search, [name]: value };

		console.log(newVal);
		this.setState({ search: newVal });
	}

	public render() {

		const meta = this.props.metadata;

		return (

			<Spin size='large' spinning={this.props.loading}>
				<div className="window window-normal">
					<div className="panel">
						<div style={{ marginBottom: '10px' }}>
							<h2>Cache store queries</h2>

						</div>
						<Row gutter={24}>
							<Col xs={4}>
								<Button onClick={() => this.props.onFlush()}>Flush cache generation</Button>
							</Col>
							<Col xs={4}>
								<Button onClick={() => this.props.onLoadMetadata()}>Reload cache metadata</Button>
							</Col>

						</Row>
						<Row gutter={24}>
							<Col xs={8}>
								{meta &&
									Object.keys(meta).map(i => {
										return (
											<div key={i}>
												<h3>{i}: <strong> {meta[i] + ''} (options)</strong></h3>
											</div>
										)
									})
								}
							</Col>
							<Col xs={16}>
								<Row gutter={24}>
									<Col xs={12}>
										<DropdownView
											label='Product type'
											multi={false}
											model={this.state.searchType}
											required={true}
											onChanged={e => this.setState({ searchType: e.id })}
											keyField='id'
											options={[
												{ id: 'Accommodation', displayName: 'Accommodation' },
												{ id: 'General', displayName: 'General' },
												{ id: 'Transfer', displayName: 'Transfer' },
												{ id: 'Carrent', displayName: 'Carrent' },
												{ id: 'Tour', displayName: 'Tour' },
											]}
											textField='displayName'
										/>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col xs={12}>
										<DateView
											label="From"
											format='date-time'
											mode='edit'
											required
											value={this.state.search.startDate}
											onChanged={e => this.setProperty('startDate', e)}
											dateUsage="utc"
										/>
									</Col>
									{this.state.searchType != 'Tour' && <Col xs={12}>
										<DateView
											label="To"
											mode='edit'
											required
											format='date-time'
											value={this.state.search.endDate}
											onChanged={e => this.setProperty('endDate', e)}
											dateUsage="utc"
										/>
									</Col>}
								</Row>
								<Row gutter={24}>
									<Col xs={24}>
										<SeachServiceProviderEditor
											type={this.state.searchType}
											value={this.state.search.apiServiceName}
											mode='edit'
											alternativeKey="apiName"
											label='Sources'
											onChange={e => {
												this.setProperty("apiServiceName", e.map(i => i.apiName))
											}}
										/>
									</Col>
								</Row>
								{this.state.searchType != 'Tour' && this.state.searchType != 'Transfer' && <Row gutter={24}>
									<Col xs={12}>
										<RegionEditorController
											setBusy={e => { }}
											label='Region'
											mode='edit'
											value={this.state.search.regionId}
											onChanged={e => { this.setProperty("regionId", !!e ? e.id : null) }}
										/>
									</Col>
									{this.state.searchType == 'Accommodation' && <Col xs={12}>
										<PlaceEditorController

											setBusy={e => { }}
											label='Place'
											mode='edit'
											value={this.state.search.placeId}
											onChanged={e => { this.setProperty("placeId", !!e ? e.id : null) }}

										/>
									</Col>}
								</Row>}
								{(this.state.searchType == 'Tour' || this.state.searchType == 'Transfer') && <Row gutter={24}>
									<Col xs={12}>
										<PlaceEditorController

											setBusy={e => { }}
											label='From place'
											mode='edit'
											value={this.state.search.fromPlaceId}
											onChanged={e => { this.setProperty("fromPlaceId", !!e ? e.id : null) }}

										/>
									</Col>
									<Col xs={12}>
										<PlaceEditorController

											setBusy={e => { }}
											label='To place'
											mode='edit'
											value={this.state.search.toPlaceId}
											onChanged={e => { this.setProperty("toPlaceId", !!e ? e.id : null) }}

										/>
									</Col>
								</Row>}

								<Row gutter={24}>
									<Col xs={12}>
										<ProductEditorController
											setBusy={e => { }}
											value={this.state.search.productId}
											mode='edit'
											label='Product'
											onChanged={e => {
												this.setProperty("productId", !!e ? e.id : null)
											}}
										/>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col xs={24}>
										<OccupanciesComponent
											searchType={this.state.searchType}
											label='Occupancy'
											values={this.state.rawOccupancy || '[]'}
											mode='edit'
											onlyOne
											initial={[
												{ name: "Adult 1", age: 30 },
												{ name: "Adult 2", age: 30 },
											]}
											onValuesChange={e => {

												const data = JSON.parse(e);

												console.log(data);

												if (!!data && data.length > 0) {
													this.setState({ rawOccupancy: e })
													if (data[0].occupancies)
														this.setProperty("units", data[0].occupancies);
												}
											}}
										/>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col xs={24}>
										<Alert
											showIcon
											message="Warning"
											description="If any field value its blank then the search is made for all the results. Like regular expression search, blank means *"
											type="warning"
											className="mb-3"
										/>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col xs={12}>
										<Button onClick={this.fromScratch}>Search</Button>
									</Col>
								</Row>
							</Col>
						</Row>



					</div>
				</div>
				<div className="window window-normal">
					<div className="panel">


						{this.props.data && <React.Fragment>
							<Row gutter={24}>
								<Col xs={24}>
									<SearchResultController
										data={this.props.data}
										searchInfo={{
											startDate: this.state.search.startDate,
											endDate: this.state.search.endDate,
											units: this.state.search.units,
											apiServiceName: this.state.search.apiServiceName
										}}
										searchType={this.state.searchType} />
								</Col>
							</Row>
						</React.Fragment>}


						{<Pagination
							onChange={page => {
								this.props.onSearch(this.state.search, this.state.searchType, page - 1, this.props.pageSize);
							}}
							current={this.props.pageIndex + 1}
							total={this.props.total}
							pageSize={this.props.pageSize}
						/>}

					</div>
				</div>
			</Spin>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/cache/cache-result-list.view.tsx